export default [
    {
        login: 'ThaELL1',
        id: 37319124,
        node_id: 'MDQ6VXNlcjM3MzE5MTI0',
        avatar_url: 'https://avatars3.githubusercontent.com/u/37319124?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/ThaELL1',
        html_url: 'https://github.com/ThaELL1',
        followers_url: 'https://api.github.com/users/ThaELL1/followers',
        following_url: 'https://api.github.com/users/ThaELL1/following{/other_user}',
        gists_url: 'https://api.github.com/users/ThaELL1/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/ThaELL1/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/ThaELL1/subscriptions',
        organizations_url: 'https://api.github.com/users/ThaELL1/orgs',
        repos_url: 'https://api.github.com/users/ThaELL1/repos',
        events_url: 'https://api.github.com/users/ThaELL1/events{/privacy}',
        received_events_url: 'https://api.github.com/users/ThaELL1/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'degreeck',
        id: 31404082,
        node_id: 'MDQ6VXNlcjMxNDA0MDgy',
        avatar_url: 'https://avatars1.githubusercontent.com/u/31404082?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/degreeck',
        html_url: 'https://github.com/degreeck',
        followers_url: 'https://api.github.com/users/degreeck/followers',
        following_url: 'https://api.github.com/users/degreeck/following{/other_user}',
        gists_url: 'https://api.github.com/users/degreeck/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/degreeck/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/degreeck/subscriptions',
        organizations_url: 'https://api.github.com/users/degreeck/orgs',
        repos_url: 'https://api.github.com/users/degreeck/repos',
        events_url: 'https://api.github.com/users/degreeck/events{/privacy}',
        received_events_url: 'https://api.github.com/users/degreeck/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'Kemmy91',
        id: 42711367,
        node_id: 'MDQ6VXNlcjQyNzExMzY3',
        avatar_url: 'https://avatars2.githubusercontent.com/u/42711367?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/Kemmy91',
        html_url: 'https://github.com/Kemmy91',
        followers_url: 'https://api.github.com/users/Kemmy91/followers',
        following_url: 'https://api.github.com/users/Kemmy91/following{/other_user}',
        gists_url: 'https://api.github.com/users/Kemmy91/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/Kemmy91/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/Kemmy91/subscriptions',
        organizations_url: 'https://api.github.com/users/Kemmy91/orgs',
        repos_url: 'https://api.github.com/users/Kemmy91/repos',
        events_url: 'https://api.github.com/users/Kemmy91/events{/privacy}',
        received_events_url: 'https://api.github.com/users/Kemmy91/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'alivanoy',
        id: 24864699,
        node_id: 'MDQ6VXNlcjI0ODY0Njk5',
        avatar_url: 'https://avatars2.githubusercontent.com/u/24864699?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/alivanoy',
        html_url: 'https://github.com/alivanoy',
        followers_url: 'https://api.github.com/users/alivanoy/followers',
        following_url: 'https://api.github.com/users/alivanoy/following{/other_user}',
        gists_url: 'https://api.github.com/users/alivanoy/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/alivanoy/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/alivanoy/subscriptions',
        organizations_url: 'https://api.github.com/users/alivanoy/orgs',
        repos_url: 'https://api.github.com/users/alivanoy/repos',
        events_url: 'https://api.github.com/users/alivanoy/events{/privacy}',
        received_events_url: 'https://api.github.com/users/alivanoy/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'Turanwest',
        id: 40670951,
        node_id: 'MDQ6VXNlcjQwNjcwOTUx',
        avatar_url: 'https://avatars1.githubusercontent.com/u/40670951?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/Turanwest',
        html_url: 'https://github.com/Turanwest',
        followers_url: 'https://api.github.com/users/Turanwest/followers',
        following_url: 'https://api.github.com/users/Turanwest/following{/other_user}',
        gists_url: 'https://api.github.com/users/Turanwest/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/Turanwest/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/Turanwest/subscriptions',
        organizations_url: 'https://api.github.com/users/Turanwest/orgs',
        repos_url: 'https://api.github.com/users/Turanwest/repos',
        events_url: 'https://api.github.com/users/Turanwest/events{/privacy}',
        received_events_url: 'https://api.github.com/users/Turanwest/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'cvsiraj95',
        id: 20457752,
        node_id: 'MDQ6VXNlcjIwNDU3NzUy',
        avatar_url: 'https://avatars2.githubusercontent.com/u/20457752?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/cvsiraj95',
        html_url: 'https://github.com/cvsiraj95',
        followers_url: 'https://api.github.com/users/cvsiraj95/followers',
        following_url: 'https://api.github.com/users/cvsiraj95/following{/other_user}',
        gists_url: 'https://api.github.com/users/cvsiraj95/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/cvsiraj95/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/cvsiraj95/subscriptions',
        organizations_url: 'https://api.github.com/users/cvsiraj95/orgs',
        repos_url: 'https://api.github.com/users/cvsiraj95/repos',
        events_url: 'https://api.github.com/users/cvsiraj95/events{/privacy}',
        received_events_url: 'https://api.github.com/users/cvsiraj95/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'sidharthchawda',
        id: 33715740,
        node_id: 'MDQ6VXNlcjMzNzE1NzQw',
        avatar_url: 'https://avatars3.githubusercontent.com/u/33715740?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/sidharthchawda',
        html_url: 'https://github.com/sidharthchawda',
        followers_url: 'https://api.github.com/users/sidharthchawda/followers',
        following_url: 'https://api.github.com/users/sidharthchawda/following{/other_user}',
        gists_url: 'https://api.github.com/users/sidharthchawda/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/sidharthchawda/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/sidharthchawda/subscriptions',
        organizations_url: 'https://api.github.com/users/sidharthchawda/orgs',
        repos_url: 'https://api.github.com/users/sidharthchawda/repos',
        events_url: 'https://api.github.com/users/sidharthchawda/events{/privacy}',
        received_events_url: 'https://api.github.com/users/sidharthchawda/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'mahmudalhakim',
        id: 16646383,
        node_id: 'MDQ6VXNlcjE2NjQ2Mzgz',
        avatar_url: 'https://avatars0.githubusercontent.com/u/16646383?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/mahmudalhakim',
        html_url: 'https://github.com/mahmudalhakim',
        followers_url: 'https://api.github.com/users/mahmudalhakim/followers',
        following_url: 'https://api.github.com/users/mahmudalhakim/following{/other_user}',
        gists_url: 'https://api.github.com/users/mahmudalhakim/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/mahmudalhakim/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/mahmudalhakim/subscriptions',
        organizations_url: 'https://api.github.com/users/mahmudalhakim/orgs',
        repos_url: 'https://api.github.com/users/mahmudalhakim/repos',
        events_url: 'https://api.github.com/users/mahmudalhakim/events{/privacy}',
        received_events_url: 'https://api.github.com/users/mahmudalhakim/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'messanjay31',
        id: 41499303,
        node_id: 'MDQ6VXNlcjQxNDk5MzAz',
        avatar_url: 'https://avatars0.githubusercontent.com/u/41499303?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/messanjay31',
        html_url: 'https://github.com/messanjay31',
        followers_url: 'https://api.github.com/users/messanjay31/followers',
        following_url: 'https://api.github.com/users/messanjay31/following{/other_user}',
        gists_url: 'https://api.github.com/users/messanjay31/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/messanjay31/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/messanjay31/subscriptions',
        organizations_url: 'https://api.github.com/users/messanjay31/orgs',
        repos_url: 'https://api.github.com/users/messanjay31/repos',
        events_url: 'https://api.github.com/users/messanjay31/events{/privacy}',
        received_events_url: 'https://api.github.com/users/messanjay31/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'jha900',
        id: 5097792,
        node_id: 'MDQ6VXNlcjUwOTc3OTI=',
        avatar_url: 'https://avatars1.githubusercontent.com/u/5097792?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/jha900',
        html_url: 'https://github.com/jha900',
        followers_url: 'https://api.github.com/users/jha900/followers',
        following_url: 'https://api.github.com/users/jha900/following{/other_user}',
        gists_url: 'https://api.github.com/users/jha900/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/jha900/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/jha900/subscriptions',
        organizations_url: 'https://api.github.com/users/jha900/orgs',
        repos_url: 'https://api.github.com/users/jha900/repos',
        events_url: 'https://api.github.com/users/jha900/events{/privacy}',
        received_events_url: 'https://api.github.com/users/jha900/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'mechack200',
        id: 39648010,
        node_id: 'MDQ6VXNlcjM5NjQ4MDEw',
        avatar_url: 'https://avatars2.githubusercontent.com/u/39648010?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/mechack200',
        html_url: 'https://github.com/mechack200',
        followers_url: 'https://api.github.com/users/mechack200/followers',
        following_url: 'https://api.github.com/users/mechack200/following{/other_user}',
        gists_url: 'https://api.github.com/users/mechack200/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/mechack200/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/mechack200/subscriptions',
        organizations_url: 'https://api.github.com/users/mechack200/orgs',
        repos_url: 'https://api.github.com/users/mechack200/repos',
        events_url: 'https://api.github.com/users/mechack200/events{/privacy}',
        received_events_url: 'https://api.github.com/users/mechack200/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'oromesuo1',
        id: 28497078,
        node_id: 'MDQ6VXNlcjI4NDk3MDc4',
        avatar_url: 'https://avatars3.githubusercontent.com/u/28497078?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/oromesuo1',
        html_url: 'https://github.com/oromesuo1',
        followers_url: 'https://api.github.com/users/oromesuo1/followers',
        following_url: 'https://api.github.com/users/oromesuo1/following{/other_user}',
        gists_url: 'https://api.github.com/users/oromesuo1/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/oromesuo1/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/oromesuo1/subscriptions',
        organizations_url: 'https://api.github.com/users/oromesuo1/orgs',
        repos_url: 'https://api.github.com/users/oromesuo1/repos',
        events_url: 'https://api.github.com/users/oromesuo1/events{/privacy}',
        received_events_url: 'https://api.github.com/users/oromesuo1/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'TaiwoOluwasegun',
        id: 43286815,
        node_id: 'MDQ6VXNlcjQzMjg2ODE1',
        avatar_url: 'https://avatars2.githubusercontent.com/u/43286815?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/TaiwoOluwasegun',
        html_url: 'https://github.com/TaiwoOluwasegun',
        followers_url: 'https://api.github.com/users/TaiwoOluwasegun/followers',
        following_url: 'https://api.github.com/users/TaiwoOluwasegun/following{/other_user}',
        gists_url: 'https://api.github.com/users/TaiwoOluwasegun/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/TaiwoOluwasegun/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/TaiwoOluwasegun/subscriptions',
        organizations_url: 'https://api.github.com/users/TaiwoOluwasegun/orgs',
        repos_url: 'https://api.github.com/users/TaiwoOluwasegun/repos',
        events_url: 'https://api.github.com/users/TaiwoOluwasegun/events{/privacy}',
        received_events_url: 'https://api.github.com/users/TaiwoOluwasegun/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'afourteia',
        id: 12877426,
        node_id: 'MDQ6VXNlcjEyODc3NDI2',
        avatar_url: 'https://avatars2.githubusercontent.com/u/12877426?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/afourteia',
        html_url: 'https://github.com/afourteia',
        followers_url: 'https://api.github.com/users/afourteia/followers',
        following_url: 'https://api.github.com/users/afourteia/following{/other_user}',
        gists_url: 'https://api.github.com/users/afourteia/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/afourteia/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/afourteia/subscriptions',
        organizations_url: 'https://api.github.com/users/afourteia/orgs',
        repos_url: 'https://api.github.com/users/afourteia/repos',
        events_url: 'https://api.github.com/users/afourteia/events{/privacy}',
        received_events_url: 'https://api.github.com/users/afourteia/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'kozen0',
        id: 32563910,
        node_id: 'MDQ6VXNlcjMyNTYzOTEw',
        avatar_url: 'https://avatars2.githubusercontent.com/u/32563910?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/kozen0',
        html_url: 'https://github.com/kozen0',
        followers_url: 'https://api.github.com/users/kozen0/followers',
        following_url: 'https://api.github.com/users/kozen0/following{/other_user}',
        gists_url: 'https://api.github.com/users/kozen0/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/kozen0/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/kozen0/subscriptions',
        organizations_url: 'https://api.github.com/users/kozen0/orgs',
        repos_url: 'https://api.github.com/users/kozen0/repos',
        events_url: 'https://api.github.com/users/kozen0/events{/privacy}',
        received_events_url: 'https://api.github.com/users/kozen0/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'vipinkrishna',
        id: 8280880,
        node_id: 'MDQ6VXNlcjgyODA4ODA=',
        avatar_url: 'https://avatars1.githubusercontent.com/u/8280880?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/vipinkrishna',
        html_url: 'https://github.com/vipinkrishna',
        followers_url: 'https://api.github.com/users/vipinkrishna/followers',
        following_url: 'https://api.github.com/users/vipinkrishna/following{/other_user}',
        gists_url: 'https://api.github.com/users/vipinkrishna/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/vipinkrishna/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/vipinkrishna/subscriptions',
        organizations_url: 'https://api.github.com/users/vipinkrishna/orgs',
        repos_url: 'https://api.github.com/users/vipinkrishna/repos',
        events_url: 'https://api.github.com/users/vipinkrishna/events{/privacy}',
        received_events_url: 'https://api.github.com/users/vipinkrishna/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'ChrisLidyard',
        id: 39034474,
        node_id: 'MDQ6VXNlcjM5MDM0NDc0',
        avatar_url: 'https://avatars1.githubusercontent.com/u/39034474?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/ChrisLidyard',
        html_url: 'https://github.com/ChrisLidyard',
        followers_url: 'https://api.github.com/users/ChrisLidyard/followers',
        following_url: 'https://api.github.com/users/ChrisLidyard/following{/other_user}',
        gists_url: 'https://api.github.com/users/ChrisLidyard/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/ChrisLidyard/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/ChrisLidyard/subscriptions',
        organizations_url: 'https://api.github.com/users/ChrisLidyard/orgs',
        repos_url: 'https://api.github.com/users/ChrisLidyard/repos',
        events_url: 'https://api.github.com/users/ChrisLidyard/events{/privacy}',
        received_events_url: 'https://api.github.com/users/ChrisLidyard/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'flex2016',
        id: 26524099,
        node_id: 'MDQ6VXNlcjI2NTI0MDk5',
        avatar_url: 'https://avatars1.githubusercontent.com/u/26524099?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/flex2016',
        html_url: 'https://github.com/flex2016',
        followers_url: 'https://api.github.com/users/flex2016/followers',
        following_url: 'https://api.github.com/users/flex2016/following{/other_user}',
        gists_url: 'https://api.github.com/users/flex2016/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/flex2016/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/flex2016/subscriptions',
        organizations_url: 'https://api.github.com/users/flex2016/orgs',
        repos_url: 'https://api.github.com/users/flex2016/repos',
        events_url: 'https://api.github.com/users/flex2016/events{/privacy}',
        received_events_url: 'https://api.github.com/users/flex2016/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'MaurickThom',
        id: 43498912,
        node_id: 'MDQ6VXNlcjQzNDk4OTEy',
        avatar_url: 'https://avatars0.githubusercontent.com/u/43498912?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/MaurickThom',
        html_url: 'https://github.com/MaurickThom',
        followers_url: 'https://api.github.com/users/MaurickThom/followers',
        following_url: 'https://api.github.com/users/MaurickThom/following{/other_user}',
        gists_url: 'https://api.github.com/users/MaurickThom/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/MaurickThom/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/MaurickThom/subscriptions',
        organizations_url: 'https://api.github.com/users/MaurickThom/orgs',
        repos_url: 'https://api.github.com/users/MaurickThom/repos',
        events_url: 'https://api.github.com/users/MaurickThom/events{/privacy}',
        received_events_url: 'https://api.github.com/users/MaurickThom/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'iambin',
        id: 5101374,
        node_id: 'MDQ6VXNlcjUxMDEzNzQ=',
        avatar_url: 'https://avatars0.githubusercontent.com/u/5101374?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/iambin',
        html_url: 'https://github.com/iambin',
        followers_url: 'https://api.github.com/users/iambin/followers',
        following_url: 'https://api.github.com/users/iambin/following{/other_user}',
        gists_url: 'https://api.github.com/users/iambin/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/iambin/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/iambin/subscriptions',
        organizations_url: 'https://api.github.com/users/iambin/orgs',
        repos_url: 'https://api.github.com/users/iambin/repos',
        events_url: 'https://api.github.com/users/iambin/events{/privacy}',
        received_events_url: 'https://api.github.com/users/iambin/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'OlhaDemydenko',
        id: 45002163,
        node_id: 'MDQ6VXNlcjQ1MDAyMTYz',
        avatar_url: 'https://avatars1.githubusercontent.com/u/45002163?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/OlhaDemydenko',
        html_url: 'https://github.com/OlhaDemydenko',
        followers_url: 'https://api.github.com/users/OlhaDemydenko/followers',
        following_url: 'https://api.github.com/users/OlhaDemydenko/following{/other_user}',
        gists_url: 'https://api.github.com/users/OlhaDemydenko/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/OlhaDemydenko/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/OlhaDemydenko/subscriptions',
        organizations_url: 'https://api.github.com/users/OlhaDemydenko/orgs',
        repos_url: 'https://api.github.com/users/OlhaDemydenko/repos',
        events_url: 'https://api.github.com/users/OlhaDemydenko/events{/privacy}',
        received_events_url: 'https://api.github.com/users/OlhaDemydenko/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'brestby',
        id: 14026212,
        node_id: 'MDQ6VXNlcjE0MDI2MjEy',
        avatar_url: 'https://avatars0.githubusercontent.com/u/14026212?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/brestby',
        html_url: 'https://github.com/brestby',
        followers_url: 'https://api.github.com/users/brestby/followers',
        following_url: 'https://api.github.com/users/brestby/following{/other_user}',
        gists_url: 'https://api.github.com/users/brestby/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/brestby/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/brestby/subscriptions',
        organizations_url: 'https://api.github.com/users/brestby/orgs',
        repos_url: 'https://api.github.com/users/brestby/repos',
        events_url: 'https://api.github.com/users/brestby/events{/privacy}',
        received_events_url: 'https://api.github.com/users/brestby/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'xipeRafa',
        id: 43357824,
        node_id: 'MDQ6VXNlcjQzMzU3ODI0',
        avatar_url: 'https://avatars3.githubusercontent.com/u/43357824?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/xipeRafa',
        html_url: 'https://github.com/xipeRafa',
        followers_url: 'https://api.github.com/users/xipeRafa/followers',
        following_url: 'https://api.github.com/users/xipeRafa/following{/other_user}',
        gists_url: 'https://api.github.com/users/xipeRafa/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/xipeRafa/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/xipeRafa/subscriptions',
        organizations_url: 'https://api.github.com/users/xipeRafa/orgs',
        repos_url: 'https://api.github.com/users/xipeRafa/repos',
        events_url: 'https://api.github.com/users/xipeRafa/events{/privacy}',
        received_events_url: 'https://api.github.com/users/xipeRafa/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'kotya',
        id: 1913221,
        node_id: 'MDQ6VXNlcjE5MTMyMjE=',
        avatar_url: 'https://avatars3.githubusercontent.com/u/1913221?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/kotya',
        html_url: 'https://github.com/kotya',
        followers_url: 'https://api.github.com/users/kotya/followers',
        following_url: 'https://api.github.com/users/kotya/following{/other_user}',
        gists_url: 'https://api.github.com/users/kotya/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/kotya/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/kotya/subscriptions',
        organizations_url: 'https://api.github.com/users/kotya/orgs',
        repos_url: 'https://api.github.com/users/kotya/repos',
        events_url: 'https://api.github.com/users/kotya/events{/privacy}',
        received_events_url: 'https://api.github.com/users/kotya/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'katerinaSo',
        id: 37941283,
        node_id: 'MDQ6VXNlcjM3OTQxMjgz',
        avatar_url: 'https://avatars3.githubusercontent.com/u/37941283?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/katerinaSo',
        html_url: 'https://github.com/katerinaSo',
        followers_url: 'https://api.github.com/users/katerinaSo/followers',
        following_url: 'https://api.github.com/users/katerinaSo/following{/other_user}',
        gists_url: 'https://api.github.com/users/katerinaSo/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/katerinaSo/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/katerinaSo/subscriptions',
        organizations_url: 'https://api.github.com/users/katerinaSo/orgs',
        repos_url: 'https://api.github.com/users/katerinaSo/repos',
        events_url: 'https://api.github.com/users/katerinaSo/events{/privacy}',
        received_events_url: 'https://api.github.com/users/katerinaSo/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'JaroslawLis',
        id: 37364317,
        node_id: 'MDQ6VXNlcjM3MzY0MzE3',
        avatar_url: 'https://avatars0.githubusercontent.com/u/37364317?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/JaroslawLis',
        html_url: 'https://github.com/JaroslawLis',
        followers_url: 'https://api.github.com/users/JaroslawLis/followers',
        following_url: 'https://api.github.com/users/JaroslawLis/following{/other_user}',
        gists_url: 'https://api.github.com/users/JaroslawLis/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/JaroslawLis/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/JaroslawLis/subscriptions',
        organizations_url: 'https://api.github.com/users/JaroslawLis/orgs',
        repos_url: 'https://api.github.com/users/JaroslawLis/repos',
        events_url: 'https://api.github.com/users/JaroslawLis/events{/privacy}',
        received_events_url: 'https://api.github.com/users/JaroslawLis/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'JustinAnthonyB',
        id: 20384195,
        node_id: 'MDQ6VXNlcjIwMzg0MTk1',
        avatar_url: 'https://avatars2.githubusercontent.com/u/20384195?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/JustinAnthonyB',
        html_url: 'https://github.com/JustinAnthonyB',
        followers_url: 'https://api.github.com/users/JustinAnthonyB/followers',
        following_url: 'https://api.github.com/users/JustinAnthonyB/following{/other_user}',
        gists_url: 'https://api.github.com/users/JustinAnthonyB/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/JustinAnthonyB/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/JustinAnthonyB/subscriptions',
        organizations_url: 'https://api.github.com/users/JustinAnthonyB/orgs',
        repos_url: 'https://api.github.com/users/JustinAnthonyB/repos',
        events_url: 'https://api.github.com/users/JustinAnthonyB/events{/privacy}',
        received_events_url: 'https://api.github.com/users/JustinAnthonyB/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'dundja',
        id: 42780673,
        node_id: 'MDQ6VXNlcjQyNzgwNjcz',
        avatar_url: 'https://avatars1.githubusercontent.com/u/42780673?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/dundja',
        html_url: 'https://github.com/dundja',
        followers_url: 'https://api.github.com/users/dundja/followers',
        following_url: 'https://api.github.com/users/dundja/following{/other_user}',
        gists_url: 'https://api.github.com/users/dundja/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/dundja/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/dundja/subscriptions',
        organizations_url: 'https://api.github.com/users/dundja/orgs',
        repos_url: 'https://api.github.com/users/dundja/repos',
        events_url: 'https://api.github.com/users/dundja/events{/privacy}',
        received_events_url: 'https://api.github.com/users/dundja/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: 'wisemanchris92',
        id: 32992448,
        node_id: 'MDQ6VXNlcjMyOTkyNDQ4',
        avatar_url: 'https://avatars1.githubusercontent.com/u/32992448?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/wisemanchris92',
        html_url: 'https://github.com/wisemanchris92',
        followers_url: 'https://api.github.com/users/wisemanchris92/followers',
        following_url: 'https://api.github.com/users/wisemanchris92/following{/other_user}',
        gists_url: 'https://api.github.com/users/wisemanchris92/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/wisemanchris92/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/wisemanchris92/subscriptions',
        organizations_url: 'https://api.github.com/users/wisemanchris92/orgs',
        repos_url: 'https://api.github.com/users/wisemanchris92/repos',
        events_url: 'https://api.github.com/users/wisemanchris92/events{/privacy}',
        received_events_url: 'https://api.github.com/users/wisemanchris92/received_events',
        type: 'User',
        site_admin: false,
    },
    {
        login: '919971603657',
        id: 19673568,
        node_id: 'MDQ6VXNlcjE5NjczNTY4',
        avatar_url: 'https://avatars0.githubusercontent.com/u/19673568?v=4',
        gravatar_id: '',
        url: 'https://api.github.com/users/919971603657',
        html_url: 'https://github.com/919971603657',
        followers_url: 'https://api.github.com/users/919971603657/followers',
        following_url: 'https://api.github.com/users/919971603657/following{/other_user}',
        gists_url: 'https://api.github.com/users/919971603657/gists{/gist_id}',
        starred_url: 'https://api.github.com/users/919971603657/starred{/owner}{/repo}',
        subscriptions_url: 'https://api.github.com/users/919971603657/subscriptions',
        organizations_url: 'https://api.github.com/users/919971603657/orgs',
        repos_url: 'https://api.github.com/users/919971603657/repos',
        events_url: 'https://api.github.com/users/919971603657/events{/privacy}',
        received_events_url: 'https://api.github.com/users/919971603657/received_events',
        type: 'User',
        site_admin: false,
    },
];
